"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toString = exports.appendUrlSearchParams = exports.generateUUID = exports.cloneDeepRawData = exports.allSettled = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _lodash = require("lodash");

var _constant = require("../constant");

/**
 * Promise.allSettled的polyfill函数
 * @param {Array} promises Promise对象集合
 */
var allSettled = function allSettled(promises) {
  var wrappedPromises = promises.map(function (p) {
    return Promise.resolve(p).then(function (val) {
      return {
        status: 'fulfilled',
        value: val
      };
    }, function (err) {
      return {
        status: 'rejected',
        reason: err
      };
    });
  });
  return Promise.all(wrappedPromises);
};
/**
 * 克隆一个原生的数据，剔除数据树携带的子表数据依赖
 * @param {*} data 要克隆的数据对象
 */


exports.allSettled = allSettled;

var cloneDeepRawData = function cloneDeepRawData(data) {
  var newData = (0, _lodash.cloneDeep)(data);
  Object.keys(newData).forEach(function (key) {
    if (typeof key === 'string' && key.split(_constant.SPLIT).length === 2) {
      // 是子table的数据集，则跳过
      delete newData[key];
    }
  });
  return newData;
};
/**
 * 获取uuid随机数
 * @param {*} count 长度
 * @param {*} raDix 随机取值范围
 */


exports.cloneDeepRawData = cloneDeepRawData;

var _char = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');

var generateUUID = function generateUUID() {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 12;
  var raDix = arguments.length > 1 ? arguments[1] : undefined;
  var uuid = [];
  var curRaDix = raDix || _char.length;

  if (count) {
    for (var i = 0; i < count; i++) {
      uuid[i] = _char[0 | Math.random() * curRaDix];
    }
  } else {
    var rfc;
    uuid[8] = '-';
    uuid[13] = '-';
    uuid[18] = '-';
    uuid[23] = '-';
    uuid[14] = '4';

    for (var _i = 0; _i < 36; _i++) {
      if (!uuid[_i]) {
        rfc = 0 | Math.random() * 16;
        uuid[_i] = _char[_i === 19 ? rfc & 0x3 | 0x8 : rfc];
      }
    }
  }

  return uuid.join('');
};
/**
 * url append params
 * @param {*} url
 * @param {*} params
 */


exports.generateUUID = generateUUID;

var appendUrlSearchParams = function appendUrlSearchParams(url, params) {
  if (Object.keys(params || {}).length === 0) return url;

  var _url$split = url.split('?'),
      _url$split2 = (0, _slicedToArray2["default"])(_url$split, 2),
      path = _url$split2[0],
      paramsString = _url$split2[1];

  var searchParams = new URLSearchParams(paramsString || '');
  Object.entries(params).forEach(function (_ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    searchParams.set(key, value);
  });
  return "".concat(path, "?").concat(searchParams.toString());
};
/**
 * 转字符串函数
 * @param {*} obj
 */


exports.appendUrlSearchParams = appendUrlSearchParams;

var toString = function toString(obj) {
  try {
    return obj.toString();
  } catch (e) {
    return obj;
  }
};

exports.toString = toString;